"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.resolveFilepath = exports.getFullDirectoryPath = void 0;
const types_1 = require("./types");
function getFullDirectoryPath(directory) {
    let workingDirPath = '';
    let workingDir = directory;
    while (workingDir.parent) {
        workingDirPath = `/${workingDir.name}${workingDirPath}`;
        workingDir = workingDir.parent;
    }
    return workingDirPath;
}
exports.getFullDirectoryPath = getFullDirectoryPath;
function resolveFilepath(path, currentDir, rootDir, returnCursorOnUndefined = false) {
    var _a;
    let dirCursor = path.startsWith('/')
        ? rootDir
        : currentDir;
    const pathParts = path.split('/').filter(Boolean);
    for (const part of pathParts) {
        if (part === '.') {
            continue;
        }
        if (part === '..') {
            dirCursor = (_a = dirCursor.parent) !== null && _a !== void 0 ? _a : dirCursor;
            continue;
        }
        const item = dirCursor.items.find((i) => i.name === part);
        if ((0, types_1.isFileSystemDirectory)(item)) {
            dirCursor = item;
            continue;
        }
        if (item === undefined) {
            return returnCursorOnUndefined ? [dirCursor, part] : [undefined, part];
        }
        return [item, null];
    }
    return [dirCursor, null];
}
exports.resolveFilepath = resolveFilepath;
//# sourceMappingURL=utils.js.map